/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Quaint_Flea_FindInputs */

const fr_fresh_quaint_flea_find = /** @type {(inputs: Fresh_Quaint_Flea_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

/**

* @param {Fresh_Quaint_Flea_FindInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fresh_quaint_flea_find = /** @type {((inputs?: Fresh_Quaint_Flea_FindInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Quaint_Flea_FindInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fresh_quaint_flea_find(inputs)
});